import VOverlay from './VOverlay.vue';

export { VOverlay };
export default VOverlay;
